<template>

  <van-form @failed="onFailed" @submit="handleSubmit" :show-error="false">
    <van-row class="non-bottom"></van-row>
    <van-field v-model="importer.countryCodeLabel" placeholder="请选择所属国" :readonly="true"
               :rules="rules.countryCodeRule" @click="countryCodeVisible = true" label="所属国" input-align="right"
               error-message-align="right" class="van-field-border van-field-required">
      <i slot="extra" class="van-icon-arrow van-cell__right-icon van-icon"></i>
    </van-field>
    <van-field v-model="importer.customerCode" label="进口商编码" type="textarea" rows="1" autosize clearable
               input-align="right" error-message-align="right" placeholder="请输入3-8位数字、字母组合的进口商编码"
               :rules="rules.customerCodeRule" class="van-field-border van-field-required"></van-field>

    <van-field v-model="importer.customerNameChinese" label="名称(中)" type="textarea" rows="1" autosize clearable
               input-align="right" error-message-align="right" placeholder="请输入进口商中文名称"
               :rules="rules.customerNameChineseRule" class="van-field-border van-field-required"></van-field>

    <van-field v-model="importer.customerNameEnglish" label="名称(英)" type="textarea" rows="1" autosize clearable
               input-align="right" error-message-align="right" placeholder="请输入进口商英文名称"
               :rules="rules.customerNameEnglishRule" class="van-field-border van-field-required"></van-field>

    <van-field v-model="importer.addressChinese"  label="地址(中)" type="textarea" rows="1" autosize clearable
               input-align="right" error-message-align="right" placeholder="请输入进口商中文地址"
               :rules="rules.addressChineseRule" class="van-field-border van-field-required"></van-field>

    <van-field v-model="importer.addressEnglish" label="地址(英)" type="textarea" rows="1" autosize clearable
               input-align="right" error-message-align="right" placeholder="请输入进口商英文地址"
               :rules="rules.addressEnglishRule" class="van-field-border van-field-required"></van-field>

    <van-field v-model="importer.email" label="EMAIL" type="textarea" rows="1" autosize clearable
               :rules="rules.emailRule" placeholder="请输入邮箱地址" input-align="right"></van-field>

    <van-field v-model="importer.contact" label="联系人" type="textarea" rows="1" autosize clearable
               placeholder="请输入联系人称呼" input-align="right" class="van-field-border"></van-field>

    <van-field v-model="importer.phoneOne" label="联系方式一" type="textarea" rows="1" autosize clearable
               placeholder="请输入联系方式一" input-align="right" class="van-field-border"></van-field>

    <van-field v-model="importer.phoneTwo" label="联系方式二" type="textarea" rows="1" autosize clearable
               placeholder="请输入联系方式二" input-align="right" class="van-field-border"></van-field>

    <van-field v-model="importer.faxOne" label="传真一" type="textarea" rows="1" autosize clearable
               placeholder="请输入传真一" input-align="right" class="van-field-border"></van-field>

    <van-field v-model="importer.faxTwo" label="传真二" type="textarea" rows="1" autosize clearable
               placeholder="请输入传真二" input-align="right" class="van-field-border"></van-field>

    <van-row class="non-bottom"></van-row>

    <van-row class="result-footer">
      <van-button round block type="info" native-type="submit">保存</van-button>
    </van-row>

    <!--所属国-->
    <van-popup v-model="countryCodeVisible" position="bottom">
      <country-picker :columns="countryOptions" @close="countryCodeVisible = false"
                      @confirm="countryCodeConfirm"></country-picker>
    </van-popup>

  </van-form>

</template>

<script>
import {noticeManager} from "@zhoujianhui/vip-core";
import CountryPicker from '../../component/CountryPicker';
import ImporterCreationDto from "../dto/ImporterCreationDto";
import importerService from "../service/importer-service";
import intelligentJudgmentService from "@/intelligent-judgment/service/intelligent-judgment-service";

export default {
  name: "importerAdd",
  components: {
    CountryPicker
  },
  data() {
    return {
      importer: new ImporterCreationDto(),
      rules: ImporterCreationDto.getRules(),
      countryCodeVisible: false,
      countryOptions: [],
      submitDataError: null
    }
  },
  created() {
    this.loadCountryOptions();
  },
  methods: {
    async loadCountryOptions() {
      const result = await intelligentJudgmentService.getCountryList();
      if (result.isSuccess()) {
        this.countryOptions = result.data.map(item => {
          return {
            value: item.countryCode,
            label: item.countryEnglish + item.countryChinese + item.countryCode
          }
        });
      } else {
        noticeManager.showMessage(result.msg, result.type);
      }
    },
    countryCodeConfirm(selectedCountry) {
      this.importer.countryCode = selectedCountry.value;
      this.importer.countryCodeLabel = selectedCountry.label;
      this.countryCodeVisible = false;
    },
    onFailed(error) {
      this.submitDataError = error;
    },
    async handleSubmit() {
      const result = await importerService.addImporter(this.importer);
      if (result.isSuccess()){
        await this.$router.go(-1);
      }
      noticeManager.showMessage(result.msg, result.type);
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "src/origin-certificate/style/form-add";
</style>
